// extracted by mini-css-extract-plugin
export default {"lastStep":"NFCSFormAddDescription_lastStep__0-DdJ","note":"NFCSFormAddDescription_note__xW+c4","warningNote":"NFCSFormAddDescription_warningNote__aA+fM"};